import { useState } from "react";
import { ExclamationTriangle, Check } from "react-bootstrap-icons";
import { getFileIcon, hexToRgba } from "./Utils";
import ContractDropDown from "./ContractDropDown";
import "./Upload.css";

const AssignmentBanner = ({ assignedCount, totalCount }) => {
  const allAssigned = assignedCount === totalCount;
  const progress = totalCount > 0 ? (assignedCount / totalCount) * 100 : 0;

  return (
    <div
      className={`assign-banner ${allAssigned ? "is-complete" : "is-incomplete"}`}
    >
      {allAssigned ? <Check size={15} /> : <ExclamationTriangle size={14} />}
      <span className="assign-banner__text">
        {allAssigned
          ? `All ${totalCount} files assigned — ready to review.`
          : `${assignedCount} of ${totalCount} files assigned.`}
      </span>
      {!allAssigned && (
        <div className="assign-banner__progress-track">
          <div
            className="assign-banner__progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
};

const DocTypeSelect = ({ value, onChange, contractFilesUploadTypes }) => {
  return (
    <select
      className="assign-doctype-select"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <option value="">Select document type…</option>
      {contractFilesUploadTypes?.map((t) => (
        <option key={t?.id} value={t?.name}>
          {t?.name}
        </option>
      ))}
    </select>
  );
};

const FileCard = ({
  file,
  onAssign,
  onDocTypeChange,
  api,
  defaultContract,
  contractFilesUploadTypes,
  customerCode,
}) => {
  const icon = getFileIcon(file.name);
  const isAssigned = !!file.contract && !!file.docType;

  return (
    <div className={`assign-file-card ${isAssigned ? "is-assigned" : ""}`}>
      <div className="assign-file-card__header">
        <span
          className="assign-file-card__type-badge"
          style={{ color: icon.color, background: hexToRgba(icon.color, 0.12) }}
        >
          {icon.label}
        </span>
        <span className="assign-file-card__name">{file.name}</span>
        <span
          className={`assign-file-card__status ${isAssigned ? "is-assigned" : ""}`}
        >
          {isAssigned ? <Check size={15} color="#48BB78" /> : "○"}
        </span>
      </div>
      <div className="assign-file-card__field">
        <ContractDropDown
          selectedId={file.contract?.id ?? null}
          onChange={(contract) => onAssign(file.id, contract)}
          api={api}
          defaultContract={defaultContract}
          customerCode={customerCode}
        />
      </div>
      <div className="assign-file-card__field">
        <DocTypeSelect
          value={file.docType}
          onChange={(docType) => onDocTypeChange(file.id, docType)}
          contractFilesUploadTypes={contractFilesUploadTypes || []}
        />
      </div>
    </div>
  );
};

export const Assign = ({
  assignments,
  onAssign,
  onDocTypeChange,
  onApplyDocTypeToAll,
  api,
  defaultContract,
  contractFilesUploadTypes,
  customerCode,
}) => {
  const [bulkDocType, setBulkDocType] = useState(null);
  const assignedCount = assignments.filter(
    (f) => f.contract && f.docType,
  ).length;

  const handleBulkDocType = (val) => {
    setBulkDocType(val);
    if (val) onApplyDocTypeToAll(val);
  };

  return (
    <div>
      <AssignmentBanner
        assignedCount={assignedCount}
        totalCount={assignments.length}
      />

      <div className="assign-bulk-row">
        <span className="assign-bulk-row__label">
          Apply document type to all files
        </span>
        <div className="assign-bulk-row__select">
          <DocTypeSelect
            value={bulkDocType}
            onChange={handleBulkDocType}
            contractFilesUploadTypes={contractFilesUploadTypes}
          />
        </div>
      </div>

      <div className="assign-step__grid">
        {assignments.map((file) => (
          <FileCard
            key={file.id}
            file={file}
            onAssign={onAssign}
            onDocTypeChange={onDocTypeChange}
            api={api}
            defaultContract={defaultContract}
            contractFilesUploadTypes={contractFilesUploadTypes}
            customerCode={customerCode}
          />
        ))}
      </div>
    </div>
  );
};

export default Assign;
